"use client";

import clsx from "clsx";

/**
 * LtrToken wraps a mixed-script token (OrbID, LEI, DID, LC reference, HCS
 * topic ID) that must remain left-to-right inside an RTL paragraph.
 *
 * Per the Phase 12 RTL audit:
 *   - These tokens are technical identifiers — they don't translate
 *   - Bidi reordering inside an Arabic block would corrupt the visual
 *     reading order; the explicit `dir="ltr"` + `unicode-bidi: isolate`
 *     prevents that
 *   - Falls through under LTR contexts so callers can use it everywhere
 *     without conditional rendering
 */
export function LtrToken({
  children,
  mono = true,
  className,
}: {
  children: React.ReactNode;
  mono?: boolean;
  className?: string;
}) {
  return (
    <span
      dir="ltr"
      style={{ unicodeBidi: "isolate" }}
      className={clsx(mono && "font-mono", className)}
    >
      {children}
    </span>
  );
}
